import { setNewConversationSearchSource } from "../../../../store/messagingSlice"
import { addPageAction } from "../../../../utils/newrelic"

export const UnifiedViewModel = ({
    dispatch,
}: GeneralViewModel): ThreadListViewModel => {
    const handleUserClick = () => {
        dispatch(setNewConversationSearchSource("button"))
        addPageAction("DmNewConversationUserSearch", {
            actionType: "init",
            source: "button",
        })
    }

    return {
        handleUserClick,
    }
}
